import { useContent } from '@/hooks/useContent';
import { Link } from 'react-router-dom';

export default function CTABanner() {
  const { t } = useContent('home');
  const { t: tc } = useContent('common');
  const { t: imgT } = useContent('images');

  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Professional spray foam insulation being applied to wall cavities"
          className="w-full h-full object-cover object-center"
          src={imgT('cta_banner')}
        />
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/25 z-[2]"></div>
      </div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-primary-500 text-xs font-semibold uppercase tracking-widest border border-primary-500/40 rounded-full px-4 py-1 mb-4">
          {t('cta_badge')}
        </span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mt-3 leading-tight">
          {t('cta_title')}
        </h2>
        <p className="text-white/70 mt-5 text-base leading-relaxed max-w-xl mx-auto">
          {t('cta_desc')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Link
            to="/contact"
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-10 py-4 rounded-full text-sm transition-all cursor-pointer flex items-center gap-2 text-center"
          >
            <i className="ri-message-3-line w-5 h-5 flex items-center justify-center"></i>
            {tc('common_request_quote')}
          </Link>
          <a
            href="tel:+15747219810"
            className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white font-bold px-8 py-4 rounded-full text-sm transition-all cursor-pointer flex items-center gap-2 text-center"
          >
            (574) 721-9810
          </a>
        </div>
      </div>
    </section>
  );
}